import axios, { AxiosResponse, CancelToken } from "axios";
import { TwilioCallsResponse, GetCallLogsRequest } from "../../models/TwilioModels";

export const getTwilioCallLogsPage =
	(request: GetCallLogsRequest, productId: string, subscriptionId: string) =>
	async (cancelToken?: CancelToken): Promise<AxiosResponse<TwilioCallsResponse>> => {
		return await axios.post(`/api/v1/${productId}/Twilio/CallLogs/${subscriptionId}/GetCallLogs`, request, {
			cancelToken: cancelToken,
		});
	};
